import { render, staticRenderFns } from "./LicensesList.vue?vue&type=template&id=93853bf2&scoped=true"
import script from "./LicensesList.vue?vue&type=script&lang=js"
export * from "./LicensesList.vue?vue&type=script&lang=js"
import style0 from "./LicensesList.vue?vue&type=style&index=0&id=93853bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93853bf2",
  null
  
)

export default component.exports